import { Dropdown } from '@ekhodealer/ekho-common/rev';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';
import type { DropdownOptionProps } from '@ekhodealer/ekho-common/rev';

import { useStageSelection } from '../hooks/useStageSelection';

import { StageTag } from './StageTag';

export interface StageDropdownProps {
	item: LeadsTableRow;
}

/**
 * Dropdown component for changing lead stage in the details drawer.
 * Uses the shared Dropdown from the component library with StageTag options.
 */
export const StageDropdown = ({ item }: StageDropdownProps) => {
	const { stageOptions, currentStageType, handleStageSelect } = useStageSelection({
		item,
		stageReason: 'Updated from drawer',
	});

	const options: DropdownOptionProps[] = stageOptions.map((stageConfig) => ({
		id: stageConfig.stage,
		label: <StageTag stage={{ type: stageConfig.stage, name: stageConfig.name }} />,
	}));

	return (
		<Dropdown
			options={options}
			value={currentStageType ?? null}
			onSelectionChange={handleStageSelect}
			placeholder={<StageTag stage={item.stage} />}
			buttonVariant='ghost'
			size='small'
		/>
	);
};
